import { render } from "./KnowledgeCourseAdmin.vue?vue&type=template&id=1ac29f61&scoped=true"
import script from "./KnowledgeCourseAdmin.vue?vue&type=script&lang=js"
export * from "./KnowledgeCourseAdmin.vue?vue&type=script&lang=js"

import "./KnowledgeCourseAdmin.vue?vue&type=style&index=0&id=1ac29f61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac29f61"]])

export default __exports__